export default __webpack_public_path__ + "static/media/congrats-completed.7edaa2cd.svg";